import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;
export const PUBLIC_BASE_URL =
  BACKEND_URL || (typeof window !== 'undefined' ? window.location.origin : '');

export const http = axios.create({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' },
});

export const api = {
  // dashboard
  dashboard: () => http.get('/dashboard').then((r) => r.data),
  // instances
  listInstances: () => http.get('/instances').then((r) => r.data),
  createInstance: (instanceName, provider = 'evolution_go') =>
    http.post('/instances', { instanceName, provider }).then((r) => r.data),
  qrcode: (name) => http.get(`/instances/${encodeURIComponent(name)}/qrcode`).then((r) => r.data),
  state: (name) => http.get(`/instances/${encodeURIComponent(name)}/state`).then((r) => r.data),
  logoutInstance: (name) => http.post(`/instances/${encodeURIComponent(name)}/logout`).then((r) => r.data),
  deleteInstance: (name) => http.delete(`/instances/${encodeURIComponent(name)}`).then((r) => r.data),
  // groups
  listGroups: (instance, refresh = false, getParticipants = false) =>
    http.get('/groups', { params: { instance, refresh, getParticipants } }).then((r) => r.data),
  createGroup: (body) => http.post('/groups', body).then((r) => r.data),
  bulkCreateGroups: (body) => http.post('/groups/bulk', body).then((r) => r.data),
  updateSubject: (body) => http.post('/groups/subject', body).then((r) => r.data),
  updateDescription: (body) => http.post('/groups/description', body).then((r) => r.data),
  updatePicture: (body) => http.post('/groups/picture', body).then((r) => r.data),
  updateSetting: (body) => http.post('/groups/setting', body).then((r) => r.data),
  updateParticipants: (body) => http.post('/groups/participants', body).then((r) => r.data),
  inviteCode: (instance, groupJid) =>
    http.get('/groups/invite', { params: { instance, groupJid } }).then((r) => r.data),
  revokeInvite: (body) => http.post('/groups/invite/revoke', body).then((r) => r.data),
  leaveGroup: (body) => http.post('/groups/leave', body).then((r) => r.data),
  // messages
  sendNow: (body) => http.post('/messages/send-now', body).then((r) => r.data),
  schedule: (body) => http.post('/messages/schedule', body).then((r) => r.data),
  listDispatches: (params = {}) => http.get('/dispatches', { params }).then((r) => r.data),
  getDispatch: (id) => http.get(`/dispatches/${id}`).then((r) => r.data),
  exportDispatchUrl: (id) => `${API}/dispatches/${encodeURIComponent(id)}/export`,
  updateDispatch: (id, body) => http.patch(`/dispatches/${id}`, body).then((r) => r.data),
  pauseDispatch: (id) => http.post(`/dispatches/${id}/pause`).then((r) => r.data),
  resumeDispatch: (id) => http.post(`/dispatches/${id}/resume`).then((r) => r.data),
  cancelDispatch: (id) => http.delete(`/dispatches/${id}`).then((r) => r.data),
  listBroadcastBases: () => http.get('/broadcast-bases').then((r) => r.data),
  createBroadcastBase: (body) => http.post('/broadcast-bases', body).then((r) => r.data),
  updateBroadcastBase: (id, body) => http.patch(`/broadcast-bases/${id}`, body).then((r) => r.data),
  deleteBroadcastBase: (id) => http.delete(`/broadcast-bases/${id}`).then((r) => r.data),
  // short links
  listShortLinks: () => http.get('/short-links').then((r) => r.data),
  createShortLink: (body) => http.post('/short-links', body).then((r) => r.data),
  updateShortLink: (id, body) => http.patch(`/short-links/${id}`, body).then((r) => r.data),
  deleteShortLink: (id) => http.delete(`/short-links/${id}`).then((r) => r.data),
  shortLinkClicks: (id, limit = 100) => http.get(`/short-links/${id}/clicks`, { params: { limit } }).then((r) => r.data),
  // logs
  listLogs: (params = {}) => http.get('/logs', { params }).then((r) => r.data),
  // CRM / Inbox
  crmStages: () => http.get('/crm/stages').then((r) => r.data),
  updateCrmStages: (body) => http.put('/crm/stages', body).then((r) => r.data),
  crmConversations: (params = {}) => http.get('/crm/conversations', { params }).then((r) => r.data),
  crmMessages: (id) => http.get(`/crm/conversations/${encodeURIComponent(id)}/messages`).then((r) => r.data),
  crmSendReply: (id, body) => http.post(`/crm/conversations/${encodeURIComponent(id)}/send`, body).then((r) => r.data),
  crmContacts: (params = {}) => http.get('/crm/contacts', { params }).then((r) => r.data),
  updateCrmContact: (id, body) => http.patch(`/crm/contacts/${encodeURIComponent(id)}`, body).then((r) => r.data),
  // user campaigns
  listCampaigns: (params = {}) => http.get('/user-campaigns', { params }).then((r) => r.data),
  createCampaign: (body) => http.post('/user-campaigns', body).then((r) => r.data),
  getCampaign: (id) => http.get(`/user-campaigns/${id}`).then((r) => r.data),
  campaignMetrics: (id, days = 1) => http.get(`/user-campaigns/${id}/metrics`, { params: { days } }).then((r) => r.data),
  updateCampaign: (id, body) => http.patch(`/user-campaigns/${id}`, body).then((r) => r.data),
  deleteCampaign: (id) => http.delete(`/user-campaigns/${id}`).then((r) => r.data),
  createCampaignGroup: (cid, body) => http.post(`/user-campaigns/${cid}/groups`, body).then((r) => r.data),
  bulkCreateCampaignGroups: (cid, body) => http.post(`/user-campaigns/${cid}/groups/bulk`, body).then((r) => r.data),
  importGroupsToCampaign: (cid, body) => http.post(`/user-campaigns/${cid}/groups/import`, body).then((r) => r.data),
  unlinkCampaignGroup: (cid, gid) => http.delete(`/user-campaigns/${cid}/groups/${gid}`).then((r) => r.data),
  setCampaignGroupAvailability: (cid, gid, isActive) =>
    http.post(`/user-campaigns/${cid}/groups/${gid}/availability`, { isActive }).then((r) => r.data),
  bulkUpdateCampaignGroups: (cid, body) => http.post(`/user-campaigns/${cid}/groups/bulk-update`, body).then((r) => r.data),
  refreshCampaignInvites: (cid) => http.post(`/user-campaigns/${cid}/groups/refresh-invites`).then((r) => r.data),
  campaignActions: (cid, limit = 300) => http.get(`/user-campaigns/${cid}/actions`, { params: { limit } }).then((r) => r.data),
  listScheduledActions: (cid, limit = 300) => http.get(`/user-campaigns/${cid}/scheduled-actions`, { params: { limit } }).then((r) => r.data),
  createScheduledAction: (cid, body) => http.post(`/user-campaigns/${cid}/scheduled-actions`, body).then((r) => r.data),
  runScheduledActionNow: (cid, id) => http.post(`/user-campaigns/${cid}/scheduled-actions/${id}/run-now`).then((r) => r.data),
  cancelScheduledAction: (cid, id) => http.post(`/user-campaigns/${cid}/scheduled-actions/${id}/cancel`).then((r) => r.data),
  deleteScheduledAction: (cid, id) => http.delete(`/user-campaigns/${cid}/scheduled-actions/${id}`).then((r) => r.data),
  broadcastTargets: (cid, excludeAdmins = true) =>
    http.get(`/user-campaigns/${cid}/broadcast-targets`, { params: { excludeAdmins } }).then((r) => r.data),
  exportLeadsUrl: (cid) => `${API}/user-campaigns/${cid}/leads.csv`,
  uploadImage: (body) => http.post('/uploads/image', body).then((r) => r.data),
  uploadMedia: (file) => {
    const form = new FormData();
    form.append('file', file);
    return axios.post(`${API}/uploads/media`, form).then((r) => r.data);
  },
  listAutomations: (cid) => http.get(`/user-campaigns/${cid}/automations`).then((r) => r.data),
  createAutomation: (cid, body) => http.post(`/user-campaigns/${cid}/automations`, body).then((r) => r.data),
  updateAutomation: (cid, id, body) => http.patch(`/user-campaigns/${cid}/automations/${id}`, body).then((r) => r.data),
  deleteAutomation: (cid, id) => http.delete(`/user-campaigns/${cid}/automations/${id}`).then((r) => r.data),
  // funnel mode
  updateCampaignSendhook: (cid, body) => http.patch(`/user-campaigns/${cid}/sendhook`, body).then((r) => r.data),
  testCampaignSendhook: (cid, body = {}) => http.post(`/user-campaigns/${cid}/sendhook/test`, body).then((r) => r.data),
  updateCampaignSettings: (cid, body) => http.patch(`/user-campaigns/${cid}/settings`, body).then((r) => r.data),
  provisionGroups: (cid, count = null) => http.post(`/user-campaigns/${cid}/provision`, { count }).then((r) => r.data),
  refreshSizes: (cid) => http.post(`/user-campaigns/${cid}/refresh-sizes`).then((r) => r.data),
  publicQrUrl: (cid) => `${API}/user-campaigns/${cid}/qr.svg`,
};
